import F from 'offline/filter/constants'
import DB from 'offline/db'
import Util from 'offline/util'
// Port of api/fuel/app/classes/filter/package/games/game/data/renames.php
export default {
	run: function(filter, data, config, global) {
		global.renames = {}
		if (config.ownerType !== F.OWNER_USER) return
		if (!global.gameIds || !global.gameIds.length) return
		var sql = 'SELECT game_id, custom_rename_text FROM custom_rename WHERE user_id = ? AND game_id IN(' + Util.in(global.gameIds) + ')'
		var params = [global.ownerID]
		if (config.sessionID !== global.ownerID) sql += ' AND custom_rename_public = 1'
		var rows = DB.query(sql, params)
		for (var i = 0; i < rows.length; i++) {
			global.renames[rows[i].game_id] = rows[i].custom_rename_text
		}
	}
}
